export default "__VITE_ASSET__3d91b178__"